export default function MyForm() {
    return (
        <>
            <section className="content-header">
                <h1>Form1 Style</h1>
            </section>

            <section className="content">
                <div className="box">
                    <div className="box-body">

                        <div className="panel panel-success panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <h4 className="panel-title">
                                            <i className="fa fa-file-text" aria-hidden="true"></i>
                                            <span>Documents</span>
                                        </h4>
                                    </div>
                                    <div className="col-sm-3" style={{ display: "flex" }}>
                                        <a className="btn btn-warning mr-10">
                                            <span>Save new order</span>
                                        </a>
                                        <a className="btn btn-warning">
                                            <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                    <div className="col-sm-3">
                                        <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                            <i className="fa fa-plus-circle"></i>
                                            <span>Create new document</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                <form >
                                    <div className="form-group">
                                        <div className="col">
                                            <label className="col-sm-6">
                                                Text input: <input name="myInput" className="form-control" />
                                            </label>
                                            <label className="col-sm-6">
                                                Text input: <input name="myInput" className="form-control" />
                                            </label><hr />
                                        </div>
                                    </div>
                                   
                                    <div className="form-group">
                                        <div className="col">
                                            <label className="col-sm-6">
                                        Checkbox: <input type="checkbox" name="myCheckbox" />
                                            </label>
                                        </div>
                                        </div>
                                    <hr />
                                    <p>
                                        Radio buttons:
                                        <label>
                                            <input type="radio" name="myRadio" value="option1" />
                                            Option 1
                                        </label>
                                        <label>
                                            <input type="radio" name="myRadio" value="option2" />
                                            Option 2
                                        </label>
                                        <label>
                                            <input type="radio" name="myRadio" value="option3" />
                                            Option 3
                                        </label>
                                    </p>
                                </form>
                            </div>
                            <div className="panel-footer">Panel footer</div>
                        </div>
                        <div className="box-footer"></div>
                    </div>
                </div>
            </section >
        </>
    );
}
